<div class="entities-tree-details-container information-value">
     <span *ngFor="let item of (list | keyvalue : generalService.noCompare); let last = last" class="entity-item">
        {{item.value}} {{item.key | titlecase | initialism}}{{postfix}}{{!last ? ', ' : ''}}
    </span>
</div>
